import React from "react";
import { useContextualAnalytics } from "../hooks/useContextualAnalytics";

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export default function AnalyticsProvider({
  children,
}: AnalyticsProviderProps) {
  // Initialize contextual analytics tracking that automatically
  // extracts entity context from URL parameters
  useContextualAnalytics();

  return <>{children}</>;
}
